import {ApiClientCommunication} from 'neo-common';
import {IDialogMessage} from '../Types/IDialogMessage';

export class RealityCheckGetInfoResponse extends ApiClientCommunication.ResponseBase {
    /**
     * @property currency - currency
     */
    currency: string;

    /**
     * @property totalGain - total gain for player's session
     */
    totalGain: number;

    /**
     * @property messages - list of messages to display to player
     */
    messages: Array<IDialogMessage>;

    protected internalValidate(errors: Array<string>): void {
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/RealityCheckGetInfoResponse.ts
 **/